var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPeople = function SvgPeople(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.97618 8.44451C4.28172 7.01866 5.54178 6 7 6V6C8.45822 6 9.71828 7.01866 10.0238 8.44451L11 13H3L3.97618 8.44451Z",
    stroke: "#282828",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4215 7.3721C12.1977 5.58155 13.5939 4 15.3983 4H16.6017C18.4061 4 19.8023 5.58155 19.5785 7.3721L19.3721 9.02317C19.1595 10.7238 17.7139 12 16 12V12C14.2861 12 12.8405 10.7238 12.6279 9.02317L12.4215 7.3721Z",
    stroke: "#282828",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 20V19C2 17.3431 3.34315 16 5 16H10.5",
    stroke: "#282828",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10 21V18C10 16.3431 11.3431 15 13 15H19C20.6569 15 22 16.3431 22 18V21",
    stroke: "#282828",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgPeople;